const EMPLOYEES_TABLE_READY = "employees-table-ready"

const EMPLOYEE_RESOURCES_TABLE_READY = "employee-resources-table-ready"


const SEARCH_TEXT_STATE = "employees-table-search-text-state"

const SEARCH_ATTIRTION_TEXT_STATE = "employees-attriiton-table-search-text-state"


const ROWS_PER_PAGE_STATE = "employees-table-rows-per-page-state"

const ROWS_ATTRITION_PER_PAGE_STATE = "employees-table-rows-attrition-per-page-state"


const PAGINATION_STATE = "employees-table-pagination-state"

const PAGINATION_ATTRITION_STATE = "employees-table-pagination-attrition-state"


const EMPLOYEES_ID_FOR_ACTION = "employees-table-brand-id-for-action"

const EMPLOYEE_DATA_RESOURCE_FOR_ACTION = "employee-resources-data-for-action"



const EMPLOYEES_ATTRITION_ID_FOR_ACTION = "employees-table-attrition-id-for-action"


const ADDEDIT_EMPLOYEE_READY = "employees-table-addedit-employee-ready"

const VIEW_EMPLOYEE_READY = "view-emplyee-ready"
const EMPLOYEES_ATTRITION_TABLE_READY = "employees-attrition-table-ready"


const EDIT_EMPLOYEE_ATTRITION_READY = "edit-emplyee-attrition-ready"

const EMPLOYEES_PREVIOUS_FILTER_CITY =" employees-table-previous-filter-city"
const EMPLOYEES_PREVIOUS_FILTER_DEPARTMENT =" employees-table-previous-filter-department"
const EMPLOYEES_PREVIOUS_FILTER_REPORTING_MANGER =" employees-table-previous-filter-reporting-manager"



const initialState = {
    isEmployeesTableReady: true,
    isAddEditEmployeeReady: true,
    isViewEmployeeReady:true,
    isEmployeesAttritionTableReady:true,
    isEditEmployeeAttritionReady:true,
    isEmployeeResourcesTableReady:true,
    employees: {},

    
    employeesSelectedId: null,
    employeeResourceSelectedData:null,

    employeesAttritionSelectedId: null,
    
    previousFilterCity: "",
    previousFilterDepartment: "",
    previousFilterReportingManager: "",

    previousSearchText: "",
    previousAttritonSearchText: "",

    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,

    previousAttritionRowsPerPageValue:15,
    previousPaginationAttritionValue:1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case EMPLOYEES_TABLE_READY:
            return Object.assign({}, state, { isEmployeesTableReady: action.payload })
        case EMPLOYEE_RESOURCES_TABLE_READY:
            return Object.assign({}, state, { isEmployeeResourcesTableReady: action.payload })



        case ADDEDIT_EMPLOYEE_READY:
            return Object.assign({}, state, { isAddEditEmployeeReady: action.payload })

        case VIEW_EMPLOYEE_READY:
            return Object.assign({}, state, { isViewEmployeeReady: action.payload })
        case EMPLOYEES_ATTRITION_TABLE_READY:
            return Object.assign({}, state, { isEmployeesAttritionTableReady: action.payload })
        case EDIT_EMPLOYEE_ATTRITION_READY:
            return Object.assign({}, state, { isEditEmployeeAttritionReady: action.payload })




        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case SEARCH_ATTIRTION_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousAttritonSearchText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)

        case ROWS_ATTRITION_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousAttritionRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        

        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_ATTRITION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationAttritionValue = action.payload
            return Object.assign({}, state, duplicateState)



        case EMPLOYEES_ID_FOR_ACTION:
            return Object.assign({}, state, {employeesSelectedId:action.payload})
        case EMPLOYEE_DATA_RESOURCE_FOR_ACTION:
            return Object.assign({}, state, {employeeResourceSelectedData:action.payload})



        case EMPLOYEES_ATTRITION_ID_FOR_ACTION:
            return Object.assign({}, state, {employeesAttritionSelectedId:action.payload})

        case EMPLOYEES_PREVIOUS_FILTER_CITY:
            return Object.assign({}, state, {previousFilterCity:action.payload})
        case EMPLOYEES_PREVIOUS_FILTER_DEPARTMENT:
            return Object.assign({}, state, {previousFilterDepartment:action.payload})
        case EMPLOYEES_PREVIOUS_FILTER_REPORTING_MANGER:
            return Object.assign({}, state, {previousFilterReportingManager:action.payload})



            

        default:
        return state
    
    }

}

export function employeesTableReady(data) {
    return {
        type: EMPLOYEES_TABLE_READY,
        payload: data
    }
}

export function employeeResourcesTableReady(data) {
    return {
        type: EMPLOYEE_RESOURCES_TABLE_READY,
        payload: data
    }
}




export function employeesAttritionTableReady(data) {
    return {
        type: EMPLOYEES_ATTRITION_TABLE_READY,
        payload: data
    }
}



export function addEditEmployeeReady(data) {
    return {
        type: ADDEDIT_EMPLOYEE_READY,
        payload: data
    }
}


export function editEmployeeAttritionReady(data) {
    return {
        type: EDIT_EMPLOYEE_ATTRITION_READY,
        payload: data
    }
}



export function viewEmployeeReady(data) {
    return {
        type: VIEW_EMPLOYEE_READY,
        payload: data
    }
}





export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}


export function searchAttritionTextState(searchText){
    return {
        type:SEARCH_ATTIRTION_TEXT_STATE,
        payload:searchText
    }
}




export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}
export function rowsAttritonPerPageState(rows){
    return {
        type:ROWS_ATTRITION_PER_PAGE_STATE,
        payload:rows
    }
}



export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function paginationAttritionState(pageNo){
    return{
        type:PAGINATION_ATTRITION_STATE,
        payload:pageNo
    }
}



export function employeesIdForAction(employeesId){
    return{
        type:EMPLOYEES_ID_FOR_ACTION,
        payload:employeesId
    }
}


export function employeeDataResourceForAction(data){
    return{
        type:EMPLOYEE_DATA_RESOURCE_FOR_ACTION,
        payload:data
    }
}


export function employeesAttritionIdForAction(employeesId){
    return{
        type:EMPLOYEES_ATTRITION_ID_FOR_ACTION,
        payload:employeesId
    }
}

export function employeesPriviousFilterCity(filter_city_id){
    return{
        type:EMPLOYEES_PREVIOUS_FILTER_CITY,
        payload:filter_city_id
    }
}

export function employeesPriviousFilterDepartment(filter_department_id){
    return{
        type:EMPLOYEES_PREVIOUS_FILTER_DEPARTMENT,
        payload:filter_department_id
    }
}


export function employeesPriviousFilterReportingManager(filter_reporting_manager){
    return{
        type:EMPLOYEES_PREVIOUS_FILTER_REPORTING_MANGER,
        payload:filter_reporting_manager
    }
}








// WEBPACK FOOTER //
// ./src/modules/Employees/redux/employees.js